import axios from "axios";
let config = JSON.parse(localStorage.getItem("config"));

export default {
  token: {
    name: "C3:JWT",
    get: function () {
      return localStorage.getItem(this.name);
    },
    set: function (value = null) {
      if (value != null) {
        localStorage.setItem(this.name, value);
      }
    },
    revoke: function () {
      let name = this.name;
      return new Promise(function (resolve) {
        localStorage.removeItem(name);
        resolve();
      });
    },
  },
  tour: {
    name: "C3:Tour",
    get: function (userId) {
      const c3Tour = localStorage.getItem(this.name);
      if (!JSON.parse(c3Tour || "{}")[userId]) {
        return undefined;
      }
      return JSON.parse(c3Tour)[userId];
    },
    set: function (userId = null) {
      if (userId != null) {
        const c3Tour = JSON.parse(localStorage.getItem(this.name) || "{}");
        localStorage.setItem(
          this.name,
          JSON.stringify({
            ...c3Tour,
            [userId]: true,
          })
        );
      }
    },
  },
  verify: {
    name: "C3:Verify",
    get: function () {
      return localStorage.getItem(this.name);
    },
    set: function (value = null) {
      if (value != null) {
        localStorage.setItem(this.name, value);
      }
    },
    revoke: function () {
      let name = this.name;
      return new Promise(function (resolve) {
        localStorage.removeItem(name);
        resolve();
      });
    },
  },
  user: {
    name: "C3:USER",
    get: function () {
      if (localStorage.getItem(this.name)) {
        return JSON.parse(atob(localStorage.getItem(this.name)));
      }
      return null;
    },
    set: function (value = null) {
      if (value != null) {
        localStorage.setItem(this.name, value);
      }
    },
    revoke: function () {
      let name = this.name;
      return new Promise(function (resolve) {
        localStorage.removeItem(name);
        resolve();
      });
    },
  },
  getUser: function (access_token) {
    var root = this;
    return new Promise(function (resolve, reject) {
      if (!root.user.get()) {
        axios
          .get(config.api + `/api/user`, {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          })
          .then((res) => {
            if (res.status == 200) {
              root.user.set(btoa(JSON.stringify(res.data)));
              resolve(res.data);
            }
          })
          .catch(function (err) {
            reject(err);
          });
      } else {
        resolve(root.user.get());
      }
    });
  },
  authenticated: function () {
    if (this.token.get() && this.verify.get()) {
      return true;
    }
    return false;
  },
  revoke: function () {
    let tokens = [this.user.name, this.token.name, this.verify.name];
    return new Promise(function (resolve) {
      tokens.forEach((t) => {
        localStorage.removeItem(t);
      });
      resolve();
    });
  },
  login: function (user = null, pass = null) {
    var root = this;
    config = JSON.parse(localStorage.getItem("config"));
    return new Promise(function (resolve, reject) {
      if (!user || !pass) {
        if (!user) {
          reject({ error: "login_error", message: "Username is required" });
          return;
        }

        if (!pass) {
          reject({ error: "login_error", message: "Password is required" });
          return;
        }

        reject({ error: "login_error", message: "Unknown login error" });
        return;
      }
      axios
        .post(config.api + `/api/login`, {
          username: user,
          password: pass,
        })
        .then(function (res) {
          if (res) {
            if (res.status == 200 && res.data.access_token) {
              root.token.set(res.data.access_token);
              resolve(res.data.access_token);
            } else {
              reject(res);
            }
          }
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },
};
